import { Device, ReadingsRequestDto } from '@thingslog/repositories';
import React, { FC } from 'react';
import { DeviceReadingsSelectorSpecificComponent } from './DeviceReadingsSelectorSpecific';
import { DeviceReadingsSelectorGenericComponent } from './DeviceReadingsSelectorGeneric';
import {
  SensorDataDeviceGroupOptions,
  SensorDataDeviceSensorTypeOption,
  SensorDataAllDevicesOption,
  SensorDataDeviceSensorOption,
} from '../../models';
import { SensorNameSnapshotter } from '../../utils/SensorNameSnapshotter';

interface DeviceReadingsSelectorBase {
  variant: 'specificDevice' | 'generic';
  payload: ReadingsRequestDto;
  onPayloadChange: (payload: ReadingsRequestDto) => void;
  onSubmit: () => void;
  blockInteractions: boolean;
  sensorNameSnapshotter: SensorNameSnapshotter;
}

export interface DeviceReadingsSelectorSpecificDevice extends DeviceReadingsSelectorBase {
  variant: 'specificDevice';
  deviceNumber: string;
  sensorOptions: SensorDataDeviceSensorOption[];
}

export interface DeviceReadingsSelectorGeneric extends DeviceReadingsSelectorBase {
  variant: 'generic';
  selectedDeviceNumber: string | null;
  onSelectedDeviceNumberChange: (deviceNumber: string | null) => void;
  deviceOptions: SensorDataAllDevicesOption[];
  sensorOptions: SensorDataDeviceSensorOption[];
  deviceGroupOptions: SensorDataDeviceGroupOptions[];
  deviceSensorTypeOptions: SensorDataDeviceSensorTypeOption[];
}

type DeviceReadingsSelectorProps =
  | DeviceReadingsSelectorSpecificDevice
  | DeviceReadingsSelectorGeneric;

export const DeviceReadingsSelector: FC<DeviceReadingsSelectorProps> = (
  props: DeviceReadingsSelectorProps
) => {
  const { variant } = props;

  if (variant === 'specificDevice') {
    return <DeviceReadingsSelectorSpecificComponent {...props} />;
  } else if (variant === 'generic') {
    return <DeviceReadingsSelectorGenericComponent {...props} />;
  } else {
    throw new Error('Invalid variant');
  }
};
